var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dropdown',{class:{
    'arrest-template-picker': true,
    'p-invalid': _vm.invalid,
  },attrs:{"options":_vm.templates,"disabled":_vm.disabled,"option-label":"key","placeholder":"Vali mall","append-to":"body","filter":true},model:{value:(_vm.templateSelected),callback:function ($$v) {_vm.templateSelected=$$v},expression:"templateSelected"}})}
var staticRenderFns = []

export { render, staticRenderFns }